export enum AdOrderStatusEnum {
  DRAFT = 'draft',
  AWAITING_PAYMENT = 'awaiting_payment',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  CANCELED = 'canceled',
}
